module.exports = __webpack_public_path__ + "img/ioc3.e3af2840.png";